import { Line, mixins } from 'vue-chartjs'
import dataLabels from 'chartjs-plugin-datalabels'
import annotation from 'chartjs-plugin-annotation'

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['data', 'options'],
  data() {
    return {
      gradient: null,
    }
  },
  mounted() {
    // this.addPlugin({
    //   id: ['dataLabels', 'annotation']
    // })
    /* this.chartData.datasets.forEach(element => {
      this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      console.log(element.gradient)
      this.gradient.addColorStop(0, element.gradient)
      this.gradient.addColorStop(0.8, 'rgba(0, 0, 0, 0)');
      element.backgroundColor = this.gradient;
    }); */
    this.renderChart(this.chartData, this.options)
  }
}


// WEBPACK FOOTER //
// ./src/components/LineChart.js